import { useState } from 'react';
import ActionDialog from 'components/ActionDialog.component';
import AgentSelectGroupStatus from 'components/AgentSelectGroupStatus.component';

export default function ReopenAssignConversationDialog(props) {
  const [agentId, setAgentId] = useState(null);

  const handleAccept = () => {
    if(props?.onSubmit) {
      props.onSubmit(agentId);
    }
  }

  return (
    <ActionDialog
      header={props.title}
      visible={props.visible}
      visibleSetter={props.visibleSetter}
      acceptMessage='Aceptar'
      acceptDisabled={!agentId}
      onAccept={handleAccept}
    >
      <AgentSelectGroupStatus
        lineId={props?.line?.id}
        onChange={(agent) => {
          setAgentId(agent === null ? null : agent.id);
        }}
      />
    </ActionDialog>
  );
}

ReopenAssignConversationDialog.defaultProps = {
  title: 'Realizar asignación'
}